<template>
	<section id="download" class="bg-secondary py-6">
		<b-container>
			<b-row>
				<b-col cols="12" lg="8" xl="6" class="text-center mx-auto">
					<h2 class="text-primary-dark text-uppercase font-weight-bold pb-4">Läs mer</h2>
				</b-col>
			</b-row>
			<b-row>
				<b-col cols="12" lg="9" xl="8" class="mx-auto">
					<b-row>
						<b-col cols="6" class="text-center">
							<a 	:href="$creo.browserPdfLink(pdfLink.org, pdfLink.fallback, pdfLink.page)"
								target="_blank"
								class="d-flex mx-auto bg-white rounded-circle d-inline-block align-items-center justify-content-center position-relative circle"
								@mouseover="pdf1 = true"
								@mouseout="pdf1 = false">
								<img src="../assets/img/pdf-full.png" width="150" height="196" alt="Hållbarhetsredovisning 2018/2019">
								<div 	class="d-flex bg-black-trans w-100 h-100 rounded-circle position-absolute absolute-top absolute-left text-center justify-content-center darrow"
										v-if="pdf1">
									<img src="../assets/img/icons/arrow-download.svg" width="120" height="154" alt="Ladda ner pdf">
								</div>
							</a>
							<a 	:href="$creo.browserPdfLink(pdfLink.org, pdfLink.fallback, pdfLink.page)" target="_blank" class="text-primary-dark pt-3 d-inline-block d-lg-none">
								Ladda ner pdf
							</a>
							<p class="m-0 pt-1 pt-lg-4 text-primary-dark">Hållbarhetsredovisning 2018/2019</p>
						</b-col>
						<b-col cols="6" class="text-center">
							<a 	:href="$creo.browserPdfLink(pdfLinkShort.org, pdfLinkShort.fallback, pdfLinkShort.page)"
								target="_blank"
								class="d-flex mx-auto bg-white rounded-circle d-inline-block align-items-center justify-content-center position-relative circle right"
								@mouseover="pdf2 = true"
								@mouseout="pdf2 = false">
								<img src="../assets/img/pdf-short.png" width="150" height="196" alt="Hållbarhet i korthet 2018/2019">
								<div 	class="d-flex bg-black-trans w-100 h-100 rounded-circle position-absolute absolute-top absolute-left text-center justify-content-center darrow"
										v-if="pdf2">
									<img src="../assets/img/icons/arrow-download.svg" width="120" height="154" alt="Ladda ner pdf">
								</div>
							</a>
							<a 	:href="$creo.browserPdfLink(pdfLinkShort.org, pdfLinkShort.fallback, pdfLinkShort.page)" target="_blank" class="text-primary-dark pt-3 d-inline-block d-lg-none">
								Ladda ner pdf
							</a>
							<p class="m-0 pt-1 pt-lg-4 text-primary-dark">Hållbarhet i korthet 2018/2019</p>
						</b-col>
					</b-row>
				</b-col>
			</b-row>
		</b-container>
	</section>
</template>
<script>
	export default {
		name: 'Download',
		props: {
			pdfLink: {
				default: null
			},
			pdfLinkShort: {
				default: null
			}
		},
		data() {
			return {
				pdf1: false,
				pdf2: false
			}
		}
	}
</script>
